/*
 * Copyright (c) 2025, Glasswing AI, Inc.
 * All rights reserved.
 * This software is the confidential and proprietary information of
 * Glasswing AI, Inc. ("Confidential Information").
 * You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Glasswing AI, Inc.
 */
import { Container, Row, Col, Stack } from 'react-bootstrap';
import { Table, Badge } from 'react-bootstrap';

function ProbeDetailDns({ data }) {
    const detail = data?.detail || {};
    const addrs = (detail?.addrs && typeof detail.addrs === 'object') ? detail.addrs : {};
    const ops = Array.isArray(detail?.ops) ? detail.ops : [];
  const mapStatus = (status) => {
    switch (status) {
      case 'pass':
        return <Badge bg="success">Pass</Badge>;
      default:
        return <Badge bg="danger">Fail</Badge>;
    }
  }

  return (
    <Container fluid>
        <Row>
            <Col>
                <h2>FQDN: {detail.name}</h2>
            </Col>
        </Row>
        <Row>
            <Col>
                Server: {detail.server}
            </Col>
        </Row>
        <Row>
            <Col>
                <Table>
                    <thead>
                        <tr>
                            <th>IP</th>
                            <th>TTL</th>
                            <th>Reverse</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.keys(addrs).map((k, idx) => {
                            const addr = addrs[k] || {};
                            return (
                                <tr key={idx}>
                                    <td>{k}</td>
                                    <td>{addr.ttl}</td>
                                    <td>{Array.isArray(addr.reverse) ? addr.reverse.join(', ') : ''}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </Col>
        </Row>
        <Row>
            <Col>
                <Table>
                    <thead>
                        <tr>
                            <th>Type</th>
                            <th>Name</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ops.map((op, idx) => (
                            <tr key={idx}>
                                <td>{op.type}</td>
                                <td>{op.name}</td>
                                <td>{mapStatus(op.status)}</td>
                                <td>{op.error}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Col>
        </Row>
    </Container>
  );
}

export default ProbeDetailDns;